/**
 * 系统Action常量
 *
 * Created by XuDL(Wisea) on 2016/08/24
 */
;
(function(window, $, undefined) {
	// 取得工程目录
	var localObj = window.location;
	var rootDomain = localObj.protocol + "//" + localObj.host;
	if(process.env.NODE_ENV === 'test') {//测试部署
		var basePath = rootDomain+'/equapi';
		var commonUrl = rootDomain+"/sr/";
	} else if(process.env.NODE_ENV === 'production') {//生产环境部署
		var basePath = rootDomain +"/equapi";
		var commonUrl = rootDomain+"/sr/";
	} else if(process.env.NODE_ENV === 'local') {//本地部署
		
	} else {//本地开发环境

		var basePath = "http://192.168.20.5:9018/equapi";
		var commonUrl = "http://192.168.101.25:8930/sr/";

		// var basePath = "https://www.xiawazhanhuadongzao.com";
		// var commonUrl = "https://www.xiawazhanhuadongzao.com//sr/";

	};
	// 接口调用
	var Action = {





		'ENTP_SAVEORUPDATE': basePath + '/w/equ/entp/saveOrUpdate',//保存或修改设备厂商
    'ENTP_FINDPAGELIST': basePath + '/w/equ/entp/findPageList',//查询设备厂商列表
    'ENTP_FINDINFO': basePath + '/w/equ/entp/findInfo',//查询设备厂商详细信息
    'ENTP_DEL': basePath + '/w/equ/entp/del',//删除厂商
    'EQUINFO_SAVEORUPDATE': basePath +'/w/equ/equInfo/saveOrUpdate', //保存或修改设备
    'EQUINFO_FINDPAGELIST': basePath +'/w/equ/equInfo/findPageList',//分页查询设备列表
    'EQUINFO_FINDINFO': basePath +'/w/equ/equInfo/findInfo', //查询设备详细信息
    'EQUINFO_DEL': basePath +'/w/equ/equInfo/del', //除设备
    'EQUINFO_CHECKEQUEXIST': basePath +'/w/equ/equInfo/checkEquExist',//校验设备是否存在
    'CLIENT_RESETCLIENT': basePath +'/w/equ/client/resetClient' ,//重置客户端私钥
    'CLIENT_FINDPAGELIST': basePath +'/w/equ/client/findPageList',//分页查询客户端列表
    'CLIENT_ADDCLIENT': basePath +'/w/equ/client/addClient', //新增客户端
    'EQU_MODEL_FINDPAGELIST': basePath + '/w/entp/model/findPageList',
		'EQU_ENTP_FINDLIST': basePath + '/w/equ/entp/findList',
		
    
		




		
	};
	// 设置给全局
	window.Action = Action;
	window.basePath = basePath;
	window.commonUrl = commonUrl;
	window.rootDomain = rootDomain;//浏览器域名地址
})(window, window.jQuery);


//////////////////
// WEBPACK FOOTER
// ./static/js/OstPaths.js
// module id = DsXP
// module chunks = 11